import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';

import {
    TitleWrapper,
    ContentWrapper,
    ImageWrapper,
    DataWrapper,
} from '@mlb/react-patterns/components/ContentCard/contentCard.style';

import ReelCard from './ReelCard';
import PopoverMenu from './PopoverMenu';

const Card = styled(ReelCard)`
    ${TitleWrapper} {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        max-height: 72px;
    }

    ${ContentWrapper} {
        display: flex;
    }

    ${DataWrapper} {
        flex: 1;
    }

    ${ImageWrapper} {
        max-width: 240px;
    }
`;

const ModalCard = (props) => {

    const {
        config,
        dictionary,
        removeClip,
        reorder,
        mediaPlayback,
        index,
        numberOfCards,
        openClipTrimming,
        reel,
        clipsLoading,
        imgSizes,
        ...otherProps
    } = props;

    return (
        <Card
            orientation={'landscape'}
            optionsMenu={
                <PopoverMenu
                    config={config}
                    dictionary={dictionary}
                    removeClip={removeClip}
                    reorder={reorder}
                    mediaPlayback={mediaPlayback}
                    index={index}
                    numberOfCards={numberOfCards}
                    openClipTrimming={openClipTrimming}
                />
            }
            mediaPlayback={mediaPlayback}
            reel={reel}
            isLoading={clipsLoading}
            imgSizes={imgSizes}
            {...otherProps}
        />
    );

};

ModalCard.propTypes = {
    config: PropTypes.object.isRequired,
    dictionary: PropTypes.object.isRequired,
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    mediaPlayback: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    numberOfCards: PropTypes.number.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
    reel: PropTypes.object.isRequired,
    imgSizes: PropTypes.string.isRequired,
    clipsLoading: PropTypes.bool.isRequired,
};

export default ModalCard;
